import { Outlet, createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/invoices/draft')({
  // Padre neutro: no puede redirigir aquí porque también envuelve a /draft/{id}.
  component: InvoiceDraftLayout,
})

function InvoiceDraftLayout(): JSX.Element {
  return <Outlet />
}
